module.exports = __webpack_public_path__ + "static/media/menu-clientes.5928da99.svg";